import { getStaticAssetUrl } from 'utils/url';
import { UserTotalBalance } from 'structure/pv2/dynavault/components/UserTotalBalance';
import React from 'react';
import { useUserTotalStakeAssets } from 'structure/pv2/vault/hooks/useUserTotalStakeAssets';
import { Header3 } from 'components/Typography';

const MultiAssetHeader = ({ title }: { title: string }) => {
  const assetsQuery = useUserTotalStakeAssets();

  return (
    <div
      className='rounded-main mt-8 w-full border border-[#191A1E] bg-cover bg-top px-10 py-9 max-lg:mt-0'
      style={{
        backgroundImage: `url(${getStaticAssetUrl('/sfi/static/pv2/block_cave.jpeg)')}`,
      }}
    >
      <Header3 className='text-[1.5rem] font-thin leading-[1.5rem] text-[#F7F8F8] lg:text-[2rem] lg:leading-[2rem]'>
        {title}
      </Header3>
      <div className='mt-8'>
        <UserTotalBalance balance={String(assetsQuery.data || 0)} />
      </div>
    </div>
  );
};
// eslint-disable-next-line import/no-default-export
export default MultiAssetHeader;
